import React from "react";
import "./DrugDescription.css";

function DrugDescription(){
  return (
    <div className="drug-container">
      <div className="drug-header">
        <h1>Medication Information</h1>
        <p>Important details about this medicine. Always consult a healthcare professional before use.</p>
      </div>

      <div className="drug-card">
        <h2>Drug Name</h2>
        <p><strong>Example:</strong> Amoxicillin 500mg</p>
      </div>

      <div className="drug-card">
        <h2>Classification</h2>
        <p>Antibiotic (Penicillin group)</p>
      </div>

      <div className="drug-card">
        <h2>Uses</h2>
        <ul>
          <li>Treats bacterial infections</li>
          <li>Respiratory tract infections</li>
          <li>Skin infections</li>
          <li>Ear and throat infections</li>
        </ul>
      </div>

      <div className="drug-card">
        <h2>Dosage</h2>
        <p>
          Dosage varies depending on age, condition, and medical history.
          Follow your doctor’s prescription strictly.
        </p>
      </div>

      <div className="drug-card warning">
        <h2>Warnings & Precautions</h2>
        <ul>
          <li>Do not use if allergic to penicillin</li>
          <li>Complete full course as prescribed</li>
          <li>May cause nausea or mild side effects</li>
          <li>Consult doctor during pregnancy or breastfeeding</li>
        </ul>
      </div>

      <div className="drug-footer">
        <p className="disclaimer">
          ⚠️ This is for educational purposes only and not medical advice.
        </p>
        <button onClick={() => alert("Contact a healthcare professional!")}>
          Consult Doctor
        </button>
      </div>
    </div>
  );
};

export default DrugDescription;